module.exports = __webpack_public_path__ + "static/media/loc1_img19.b3d45251.jpg";